import React, { useCallback, useState, useEffect } from 'react';
import { Sheet, Button } from '@superops/ui-design-system';

import { SelectionSheet } from '@nile/components';
import { FormattedMessage } from 'react-intl';

function ColumnConf(props) {
  const [sheetActive, setSheetActive] = useState(false);
  const toggleSheetActive = useCallback(
    () => setSheetActive((sheetActive) => !sheetActive),
    []
  );
  const {
    columns,
    sections,
    actions,
    meta,
    data,
    header,
    selectedItems,
    updateParent
  } = props;
  return (
    <div>
      <Button id="createNewColConf" onClick={toggleSheetActive}>
        <FormattedMessage id="ticket.newView.configurecol" />
      </Button>
      <Sheet open={sheetActive} onClose={toggleSheetActive}>
        <SelectionSheet
          columns={columns}
          sections={sections}
          actions={actions}
          meta={meta}
          data={data}
          header={header}
          selectedItems={selectedItems}
          updateParent={updateParent}
          toggleSheetActive={toggleSheetActive}
        ></SelectionSheet>
      </Sheet>
    </div>
  );
}

export default ColumnConf;
